// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("Conversation", {
  id: __t.u64(),
  user1Id: __t.u64(),
  user2Id: __t.u64(),
  lastMessageAt: __t.u64(),
  user1UnreadCount: __t.u32(),
  user2UnreadCount: __t.u32(),
});


